// extracted by mini-css-extract-plugin
export var currencyInput = "_lm-1";
export var currencySymbol = "_lm-0";